import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";

export class BookOfShadowsPaytableView {
    private _resizeTimeOut: NodeJS.Timeout;

    constructor() {
        this.addEventListeners();
    }

    protected addEventListeners() {
        window.addEventListener('resize', () => this.doResize());
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => this.doResize());
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.doResize());
    }

    /**
     * @description Very ugly solution to support #248.
     * @private
     */
    private doResize(): void {
        if (this._resizeTimeOut) {
            clearTimeout(this._resizeTimeOut);
        }

        this._resizeTimeOut = setTimeout(() => {
            const info: any = document.getElementsByName("INFO")[0],
                item: any = info?.contentWindow?.document.getElementById("freeSpinAnimationDiv");

            if (item) {
                const scale: number = NolimitApplication.globalScale,
                    maxWidth: number = 402,
                    maxHeight: number = 267;
                let ht: number,
                    wd: number;

                if (NolimitApplication.isLandscape) {
                    wd = maxWidth;
                    ht = maxHeight;
                } else {
                    wd = 240.828;
                    ht = 159.938;
                }

                wd *= scale;
                ht *= scale;

                item.style.width = Math.min(wd, maxWidth) + "px";
                item.style.height = Math.min(ht, maxHeight) + "px";
            }
        }, 10);
    }
}